import Vue from 'vue';
import VueRouter from 'vue-router';
import RootChrome from '@/layouts/RootChrome.vue';
import AppChrome from '@/layouts/AppChrome.vue';
import PageNotFound from '@/layouts/PageNotFound.vue';
import { guardAuth } from '@/router/guard';
import { createRoutes as createVideoRoutes } from '@/video';
import { createRoutes as createEpisodeRoutes } from '@/episode';
import { createRoutes as createProgramRoutes } from '@/program';
import { createRoutes as createGalleryRoutes } from '@/gallery';
import { createRoutes as createScheduleRoutes } from '@/schedule';
import { createRoutes as createScheduleMonthlyRoutes } from '@/scheduleMonthly';
import { createRoutes as createScheduleTemplateRoutes } from '@/scheduleTemplate';
import { createRoutes as createCollectionRoutes } from '@/collection';
import { createRoutes as createPageDesignerRoutes } from '@/pageDesigner';
import { createRoutes as createUserRoutes } from '@/user';
import { createRoutes as createProfileRoutes } from '@/profile';
import { createRoutes as createTaxonomyRoutes } from '@/taxonomy';
import { createRoutes as createCustomLinksRoutes } from '@/customLinks';
import { createRoutes as createLandingPageRoutes } from '@/landingpage';
import { createRoutes as createCommentRoutes } from '@/comment';
import { createRoutes as createLiveRoutes } from '@/live';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: RootChrome,
      children: [
        {
          path: '/login',
          component: () => import(/* webpackChunkName: "LoginPage" */ '@/auth/LoginPage.vue'),
        },
        {
          path: '/auth/:teamName',
          component: () => import('@/auth/AuthTokenLoginPage.vue'),
        },
        {
          path: '',
          component: AppChrome,
          meta: { requiresAuth: true },
          children: [
            {
              path: '/',
              redirect: 'videos',
            },
            ...createVideoRoutes(),
            ...createEpisodeRoutes(),
            ...createProgramRoutes(),
            ...createScheduleRoutes(),
            ...createScheduleTemplateRoutes(),
            ...createScheduleMonthlyRoutes(),
            ...createCollectionRoutes(),
            ...createGalleryRoutes(),
            ...createPageDesignerRoutes(),
            ...createUserRoutes(),
            ...createProfileRoutes(),
            ...createTaxonomyRoutes(),
            ...createCustomLinksRoutes(),
            ...createScheduleMonthlyRoutes(),
            ...createLandingPageRoutes(),
            ...createCommentRoutes(),
            ...createLiveRoutes(),
            {
              path: '*',
              component: PageNotFound,
            },
          ],
        },
      ],
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach(guardAuth);

export default router;
